import { Modal } from 'antd'

const MediaPreviewModal = ({ open, media, onClose }) => {
  if (!media?.url) return null

  const isVideo =
    media.type === 'VIDEO' || /\.(mp4|webm|ogg)$/i.test(media.url)

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onClose}
      centered
      width={900}
      destroyOnClose
      styles={{
        body: {
          padding: 0,
          background: '#000'
        }
      }}
    >
      {isVideo ? (
        <video
          src={media.url}
          controls
          autoPlay
          style={{
            width: '100%',
            maxHeight: '80vh',
            background: '#000'
          }}
        />
      ) : (
        <img
          src={media.url}
          alt=""
          style={{
            width: '100%',
            maxHeight: '80vh',
            objectFit: 'contain',
            display: 'block',
            margin: '0 auto',
            background: '#000'
          }}
        />
      )}
    </Modal>
  )
}

export default MediaPreviewModal
